import { Component, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import { Svglist } from './../../../../../models/editors/svglist.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SvglistEditorComponent),
  multi: true
};

@Component({
  selector: 'swb-svglist',
  templateUrl: './svglist-editor.component.html',
  styleUrls: ['./svglist-editor.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class SvglistEditorComponent extends FormEditorBase implements OnInit {
  private _onModelChanged: Function;

  public svglist: Array<{ value: string, svg: string, label?: string }>;

  public value: string;

  constructor(
    private _sanitizer: DomSanitizer
  ) {
    super();
  }

  public ngOnInit(): void {
    this.svglist = (<Svglist>this.field).svgListConfig;
  }

  public getSafeSvg(svglistItem: { key: string, svg: string }): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(svglistItem.svg);
  }

  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  public registerOnTouched(fn: Function): void {
    // noop
  }

  public writeValue(value: string) {
    this.value = value;
  }

  public setActive(value: string): void {
    this.value = value;
    this._onModelChanged(this.value);
  }
}
